"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropertyTax = function PropertyTax(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ className: "custom-icon", viewBox: "0 0 24 24" }, props),
    _react2.default.createElement("path", {
      d: "M6.27126214,11.8301221 C5.56180476,11.8301221 4.88690757,11.9000996 4.27877807,12.0380959 C3.76459386,12.1548152 3.32099033,12.2652527 2.83422712,12.36799 L2.83422712,9.98720005 L10.0758845,3.32528411 L17.1937418,9.94728043 L17.1937418,13.8813556 C17.0314874,13.9805806 16.7543569,14.0962191 16.5234689,14.2283389 C15.8844299,14.5941674 15.145929,14.8627299 14.3407415,15.021125 C14.3198918,14.4702883 13.9722618,13.9680846 13.339713,13.5855047 C13.0060368,13.3836775 12.6506185,13.2231885 12.1638553,13.0743849 L12.1638553,10.5465476 L8.02636802,10.5465476 L8.02636802,11.9629173 C7.45847761,11.8760533 6.83639423,11.8301221 6.27126214,11.8301221 Z M10.1082543,1.70978909 L1.97103369,9.19562978 L0.109732305,9.19562978 L2.99648152,6.51507118 L2.99648152,2.23840322 L5.99818798,2.23840322 L5.99818798,3.75366014 L10.09211,0 L19.9899531,9.19562978 L18.1547746,9.19562978 L10.1082543,1.70978909 Z M19.0839245,14.5177055 C20.1153757,14.5177055 20.320303,15.4003276 19.8022247,15.8422128 C18.7231518,16.7625931 14.7475133,19.4584171 12.4575358,19.9186747 C12.1761055,19.9752107 11.8377239,20 11.4598334,20 C8.7617861,20 3.99661766,18.7351357 2.8189752,18.7351357 C2.17725904,18.7351357 1.04959094,19.0207872 0.0760645161,19.3188673 L0.0760645161,14.1529577 C0.562827726,14.021716 2.27120434,13.6174539 4.63533212,13.0808018 C5.1560065,12.9625965 5.7170011,12.9107888 6.28481038,12.9107888 C7.64677384,12.9108563 9.07696528,13.2090039 10.2487666,13.6040122 C11.8493251,14.1432986 13.3800332,14.43969 12.9851871,15.3602053 C12.8997601,15.5592631 12.5346066,15.6259309 12.0577409,15.6259309 C11.0886765,15.6259309 9.65872844,15.3504112 9.18186275,15.3504112 C8.94440343,15.3504112 8.94318652,15.4187001 9.35255438,15.623229 C10.1788349,16.036002 11.3488514,16.2680221 12.6163017,16.2680221 C14.1754043,16.2680221 15.8817527,15.9167159 17.2756803,15.1189314 C18.0381948,14.6825174 18.6382116,14.5177055 19.0839245,14.5177055 Z",
      id: "path-1"
    }),
    ";"
  );
};

exports.default = PropertyTax;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/property-tax.js
// module id = ../lib/egov-ui-kit/custom-icons/property-tax.js
// module chunks = 504